module.exports = __webpack_public_path__ + "static/media/accessories-3.7d4bff99.jpg";